import { FormControl, InputLabel, Select, SelectChangeEvent, SelectProps, SxProps, ThemeProvider } from '@mui/material';

import styles from './select-component.module.scss';
import { whiteTheme } from '@/types';

export type SelectComponentProps = SelectProps & {
  selectLabel: string;
  selectedValue: string | string[] | number;
  handleChange: (event: SelectChangeEvent<any>) => void;
  selectOptions: JSX.Element[];
  formControlSx?: SxProps;
  selectId: string;
  labelId: string;
};

const SelectComponent = ({
  selectOptions,
  selectLabel,
  selectedValue,
  handleChange,
  formControlSx = { minWidth: 216, m: 2 },
  labelId,
  selectId,
  sx,
  ...rest
}: SelectComponentProps) => {
  return (
    <ThemeProvider theme={whiteTheme}>
      <FormControl sx={formControlSx} className={styles.formControl} variant={rest.variant ?? 'outlined'}>
        <InputLabel id={labelId} htmlFor={selectId} sx={{ color: 'var(--select-color)' }}>
          {selectLabel}
        </InputLabel>
        <Select
          labelId={labelId}
          id={selectId}
          label={selectLabel}
          value={selectedValue}
          onChange={handleChange}
          sx={{
            ...sx,
            color: 'var(--select-color)',
            '.MuiOutlinedInput-notchedOutline': {
              borderColor: 'var(--select-color)',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: 'var(--select-color)',
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: 'var(--select-color)',
            },
            '.MuiSvgIcon-root': {
              fill: 'white !important',
            },
            // Root class for the input field
            '& .MuiOutlinedInput-root': {
              color: 'var(--select-color)',
              fontFamily: 'Arial',
              fontWeight: 'bold',
              // Class for the border around the input field
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: 'var(--select-color)',
                borderWidth: '2px',
              },
            },
            // // Class for the label of the input field
            '& .MuiInputLabel-outlined': {
              color: 'var(--select-color)',
              fontWeight: 'bold',
            },

            '& .MuiSvgIcon-root': {
              color: 'var(--select-color)',
            },
          }}
          {...rest}
        >
          {selectOptions}
        </Select>
      </FormControl>
    </ThemeProvider>
  );
};

export default SelectComponent;
